function change_form() {
    $("#form_login").prop('id', 'forgot_pwd');
    $("#loginpwd").slideUp('fast');
    $("#hidedeze").slideUp('fast');
    $("#label-loginpwd2").hide();
    $("#sendbutton_login").slideUp('fast');
    $("#forgot_text").slideUp('fast');
    $("#forgot_text2").slideDown('fast');
    $("#sendbutton_forgotpwd").slideDown('fast');
    $("#text_intro").slideUp('fast');
    $("#text_forgot").slideDown('fast');
}

function change_form2() {
    $("#forgot_pwd").prop('id', 'form_login');
    $("#loginpwd").slideDown('fast');
    $("#hidedeze").slideDown('fast');
    $("#label-loginpwd2").show();
    $("#sendbutton_login").slideDown('fast');
    $("#forgot_text").slideDown('fast');
    $("#forgot_text2").slideUp('fast');
    $("#sendbutton_forgotpwd").slideUp('fast');
    $("#text_intro").slideDown('fast');
    $("#text_forgot").slideUp('fast');
}

function try_login() {
    var datastring = $("#form_login").serialize();
    $.ajax({
        type: "POST",
        url: "/ajax/ajax_login.php",
        data: datastring,
        dataType: "json",
        cache: false,
    }).done(function(data) {
        var hetresult = JSON.stringify(data);
        var obj = JSON.parse(hetresult);
        var success = obj.success;
        var error = obj.error;
        var response = obj.response;

        if (success == 1) location.reload();

        if (error == 1) {
            $("#loginfailed").slideDown('fast');
            $("#loginemail").addClass('err');
            $("#loginpwd").addClass('err');
            //alert("Error -> show error");
        }
    }).fail(function() {
        alert("error - contact support if occurs often");
    });
};


function checkForm() {
    $("#phone").removeClass('err');
    $("#registration_error").slideUp('fast');
    $("#register_exist").slideUp('fast');
    $("#firstname_empty").slideUp('fast');
    $("#lastname_empty").slideUp('fast');
    $("#email_empty").slideUp('fast');
    $("#email_empty2").slideUp('fast');
    $("#registerfailed").slideUp('fast');
    $("#password_empty").slideUp('fast');
    $("#password_amount").slideUp('fast');
    $("#terms_empty").slideUp('fast');

    var x = document.forms["form_register"]["RealPhone"].value;
    var regex = /^[0-9]+$/;
    if (!x.match(regex)) { $("#phone").addClass('err'); }

    return $('input[type=text]').filter(function() {
        return $(this).val().length === 0;
    }).removeClass('err');
    return $('input[type=password]').filter(function() {
        return $(this).val().length === 0;
    }).removeClass('err');
};

function try_register() {
    const form_register = document.getElementById("form_register");

    if ('reportValidity' in form_register && form_register.reportValidity() === false) return;

    var Phone = $("#phone").intlTelInput("getNumber");
    $("#RealPhone").val(Phone);

    var datastring = $("#form_register").serialize();

    $.ajax({
        type: "POST",
        url: "/ajax/ajax_register.php",
        data: datastring,
        dataType: "json",
        cache: false,
    }).done(function(obj) {
        var success = obj.success;
        var error = obj.error;
        var response = obj.response;
        var response_exist = obj.response_exist;
        var response_firstname = obj.response_firstname;
        var response_lastname = obj.response_lastname;
        var response_email = obj.response_email;
        var response_pwdcheck = obj.response_pwdcheck;
        var response_pwd = obj.response_pwd;
        var response_pwd_chars = obj.response_pwd_chars;
        var response_terms = obj.response_terms;
        var dir_code = obj.dircode;
        var tracking = obj.tracking;

        if (success == 1) {
            $("#register_success").slideDown('fast');

            if (tracking) {
                window.location.href = "index.php?dir=" + dir_code + "&p=register_tracking";
            } else {
                setTimeout(function() { location.reload(); }, 2000);
            }
        }

        if (error == 1) {
            if (response == "error_insertid") {
                $("#registration_error").slideDown('fast');
            }

            if (response_exist == "error_exist") {
                $("#register_exist").slideDown('fast');
                $("#email").addClass('err');
            }
            if (response_firstname == "error_firstname") {
                $("#firstname_empty").slideDown('fast');
                $("#firstname").addClass('err');
            }
            if (response_lastname == "error_lastname") {
                $("#lastname_empty").slideDown('fast');
                $("#lastname").addClass('err');
            }
            if (response_email == "error_email") {
                $("#email_empty").slideDown('fast');
                $("#email").addClass('err');
            }
            if (response_email == "error_email2") {
                $("#email_empty2").slideDown('fast');
                $("#email").addClass('err');
            }
            if (response_pwdcheck == "error_passwordcheck") {
                $("#registerfailed").slideDown('fast');
                $("#password1").addClass('err');
                $("#password2").addClass('err');
            }
            if (response_pwd == "error_password") {
                $("#password_empty").slideDown('fast');
                $("#password1").addClass('err');
                $("#password2").addClass('err');
            }
            if (response_pwd_chars == "error_password_chars") {
                $("#password_amount").slideDown('fast');
                $("#password1").addClass('err');
            }
            if (response_terms == "error_terms") {
                $("#terms_empty").slideDown('fast');
                $("#terms_check").addClass('err');
            }

            if (obj.response_tel != "") {
                $("#phone").addClass('err');
            }

            if (obj.response_tel != "") {
                $("#phone").addClass('err');
            }

            if (obj.response_cust_1 != "") {
                $("#custom_1").addClass('err');
            }

            if (obj.response_cust_2 != "") {
                $("#custom_2").addClass('err');
            }

            if (obj.response_bday != "") {
                $("#birth").addClass('err');
            }
        }
    }).fail(function(data) {
        var hetresult = JSON.stringify(data);
        alert(hetresult);
        alert("error - contact support if occurs often");
    });
};


function ShowPwd1() {
    var x = document.getElementById("password1");
    if (x.type === "password") {
        x.type = "text";
    } else {
        x.type = "password";
    }
}

function ShowPwd2() {
    var x = document.getElementById("password2");
    if (x.type === "password") {
        x.type = "text";
    } else {
        x.type = "password";
    }
}

function ShowPwd3() {
    var x = document.getElementById("loginpwd");
    if (x.type === "password") {
        x.type = "text";
    } else {
        x.type = "password";
    }
}